import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ControlTowerRoutes from './ControlTower';

const Routes = () => {
  return (
    <Router basename="/">
      <ControlTowerRoutes />
    </Router>
  );
};

export default Routes;
